import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons'; 
import '../css/Header.css'; 
import logo from '../assets/logowhite.png'; 

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isThemesOpen, setIsThemesOpen] = useState(false);
  const navigate = useNavigate(); 

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleThemeClick = (id) => {
    navigate('/'); 
    if (window.innerWidth > 768) {
      setIsThemesOpen(!isThemesOpen); 
    }
    scrollToSection(id);
  };

  const handleMenuClick = (id) => {
    navigate('/');
    setIsThemesOpen(false);
    scrollToSection(id);
    setIsMenuOpen(false); 
  };

  return (
    <header className="header">
            <div className="logo">
        <img src={logo} alt="AI-DePIN Logo" />
      </div>
      <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
        <FontAwesomeIcon icon={faBars} />
      </button>
      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li onClick={() => handleMenuClick('welcome')}>Home</li>
          <div className="vertical-divider"></div>
          <li><Link to="/Roadmap" onClick={() => setIsMenuOpen(false)}>Roadmap</Link></li> 
          <div className="vertical-divider"></div>
          <li><Link to="/Tokenomics" onClick={() => setIsMenuOpen(false)}>Tokenomics</Link></li>
          <div className="vertical-divider"></div>

          <li><Link to="/wallet" onClick={() => setIsMenuOpen(false)}>Wallet</Link></li> 
          <div className="vertical-divider"></div>
          <li><a href="https://ai-depin.gitbook.io/overview/white-paper" target="_blank" rel="noopener noreferrer">White paper</a></li>
          <div className="vertical-divider"></div>
          <li><a href="https://explorer.ai-depin.org" target="_blank" rel="noopener noreferrer">Explorer</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
